import { emitDiagnostics } from 'mini-diagnostics/lib/events/diagnosticsEventsManager';
import { executeDiagnosticsTask } from 'mini-diagnostics/lib/utils/executeDiagnosticsTask';
import { trackActivity } from '../actions/trackActivity';
import type { WORKFLOW_STATES } from 'mini-diagnostics/lib/schema/WorkflowStates';

export const trackWorkflowActivity = (
    workflowName: string,
    workflowState: WORKFLOW_STATES,
    customData?: unknown
) => {
    executeDiagnosticsTask(() => {
        trackActivity({
            workflowName,
            workflowState,
            payload: customData,
        });

        // publish signal
        emitDiagnostics({
            name: 'WorkflowActivity',
            data: { name: workflowName, workflowState },
        });
    });
};
